import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { content, tosPage } from '@/utils/tos';
import { LayoutWithHeader } from '@/components/layout/Layout';
import Desktop from '@/components/ui/tos/desktop/Desktop';
import Mobile from '@/components/ui/tos/mobile/Mobile';

export default function Index() {
  const router = useRouter();
  const {
    query: { id },
  } = router;

  const page = Array.isArray(id) ? id[0] : id;
  const isValid = Object.values(tosPage).some(validPage => validPage === page);

  useEffect(() => {
    if (!isValid) {
      router.push('/tos/mapping-network', undefined, { shallow: true });
    }
  }, [page, isValid]);

  const defaultPage = isValid ? (page as tosPage) : tosPage.mappingNetwork;
  const data = content[defaultPage];
  const sections = data.sections;

  return (
    <LayoutWithHeader>
      <Mobile data={data} sections={sections} page={defaultPage} />
      <Desktop data={data} sections={sections} page={defaultPage} />
    </LayoutWithHeader>
  );
}
